import oidcTemplateUrl from '../../../app/oidc/oidc.tpl.html';

const validTokenLengths = [2, 3];

const OidcController = [
    '$http',
    '$scope',
    '$q',
    '$log',
    '$location',
    '$window',
    'security',
    'loginService',
    'ssoRedirect',
    'DOMAIN_ORGANIZATION_ID',
    'API_V2_URL',
    'auth',
    'currentUser',
    function (
        $http,
        $scope,
        $q,
        $log,
        $location,
        $window,
        security,
        loginService,
        ssoRedirect,
        DOMAIN_ORGANIZATION_ID,
        API_V2_URL,
        auth,
        currentUser
    ) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $scope.processOidcToken($ctrl.token);
        };

        function exchangeSessionWithToken(token) {
            if (!token) {
                $log.error('Missing OIDC token');
                return $q.reject(null);
            }
            const tokenParts = token.split(':::');
            function respond() {
                if (validTokenLengths.includes(tokenParts.length)) {
                    const payload = {
                        code: tokenParts[0],
                        orgId: DOMAIN_ORGANIZATION_ID,
                        integrationId: tokenParts[1],
                    };
                    if (tokenParts.length === 3) {
                        payload.orgUserId = tokenParts[2];
                    }
                    return $http({
                        method: 'POST',
                        url: API_V2_URL + '/session/oidc/exchange',
                        data: payload,
                    });
                } else {
                    $log.error('Invalid OIDC token for session exchange');
                    return $q.reject(null);
                }
            }
            return security.logout().then(respond, respond);
        }

        $scope.processOidcToken = function (token) {
            exchangeSessionWithToken(token)
                .then((result) => {
                    const sessionToken =
                        result && (result.data?.accessToken || result.data?.sf_accessToken);
                    if (sessionToken && auth.authToken() !== sessionToken) {
                        auth.setAuth(sessionToken);
                    }
                    currentUser.clearUserCache();
                    return loginService.initOrgAndUserPostLogin();
                })
                .then(() => {
                    const url = ssoRedirect.getAndClear();
                    if (url) {
                        $location.url(url);
                    } else {
                        $location.path('/home');
                    }
                })
                .catch((e) => {
                    $window.alert('Sign-in failed. Error: Invalid token.');
                    $log.error('Error exchanging OIDC token', e);
                    $location.path('/signin');
                });
        };
    },
];

// there is no ui for the oidc token exchange
// it's just a redirect to homepage
// with an intermediate step of exchanging
// the identity token for an access token
export default {
    bindings: { token: '<' },
    templateUrl: oidcTemplateUrl,
    controller: OidcController,
};
